import {yupResolver} from "@hookform/resolvers/yup";
import {Button, Input, Space} from "antd";
import {useState} from "react";
import {useForm} from "react-hook-form";
import {useSendEmailChangeOtp} from "../../../react-query-hooks/settings";
import {CustomInputComponent} from "../../input/input-component";
import {emailUpdateSchema} from "./email-update-form-schema";
import {StyledEmailUpdateFormContainer} from "./email-update-form.style";
import {IEmailUpdateFormValues} from "./i-email-update-form";
import {VerifyEmailModal} from "./verify-email-modal";

const EmailUpdateForm = ({email}: {email: string}) => {
  return <EmailUpdateFormV2 email={email} />;
};

const EmailUpdateFormV2 = ({email}: {email: string}) => {
  const [isOtpModalVisible, setIsOtpModalVisible] = useState(false);
  const [newEmail, setNewEmail] = useState("");
  const sendOtpMutation = useSendEmailChangeOtp();

  const {
    handleSubmit,
    formState: {errors},
    watch,
    control,
  } = useForm<IEmailUpdateFormValues>({
    resolver: yupResolver(emailUpdateSchema),
    mode: "onChange",
  });

  const onSubmit = async (values: IEmailUpdateFormValues) => {
    const emailToChange = values.emailAddress.toLowerCase();
    setNewEmail(emailToChange);
    sendOtpMutation.mutate(undefined, {
      onSuccess: () => {
        setIsOtpModalVisible(true);
      },
    });
  };

  const handleOtpSuccess = () => {
    setIsOtpModalVisible(false);
    setNewEmail("");
  };

  return (
    <div>
      <StyledEmailUpdateFormContainer>
        <h2 className="email-heading-text">Update email address</h2>
      </StyledEmailUpdateFormContainer>
      <form onSubmit={handleSubmit(onSubmit)} style={{marginTop: "2.4rem"}}>
        <Space direction="vertical" size={24} style={{display: "flex"}}>
          <div>
            <label
              htmlFor="currentEmail"
              style={{display: "block", marginBottom: "8px", fontSize: "1.4rem"}}
            >
              Current email
            </label>
            <Input
              id="currentEmail"
              type="email"
              value={email.toLowerCase()}
              disabled={true}
              size="large"
            />
          </div>
          <div>
            <label
              htmlFor="emailAddress"
              style={{display: "block", marginBottom: "8px", fontSize: "1.4rem"}}
            >
              New email address
            </label>
            <CustomInputComponent
              id="emailAddress"
              name="emailAddress"
              type="email"
              placeholder="Enter email address"
              error={errors.emailAddress?.message}
              control={control}
            />
          </div>
          <div>
            <Button
              disabled={
                Object.keys(errors).length > 0 ||
                Object.values(watch()).length < 1 ||
                watch("emailAddress")?.toLowerCase() === email.toLowerCase()
              }
              loading={sendOtpMutation.isLoading}
              size="small"
              type="primary"
              htmlType="submit"
            >
              Change email address
            </Button>
          </div>
        </Space>
      </form>
      <VerifyEmailModal
        visible={isOtpModalVisible}
        currentEmail={email.toLowerCase()}
        newEmail={newEmail}
        onClose={() => {
          setIsOtpModalVisible(false);
          setNewEmail("");
        }}
        onSuccess={handleOtpSuccess}
      />
    </div>
  );
};

export {EmailUpdateForm};
